import clsx from 'clsx';
import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

type ProductCardSkeletonProps = {
  optionalStyles?: CSSProperties;
};

const ProductCardSkeleton: React.FC<ProductCardSkeletonProps> = ({ optionalStyles = {} }) => {
  return (
    <div className={styles['card-skeleton']} style={optionalStyles}>
      <div className={clsx(styles['card-image'], styles['pulsate'])} />
      <div className={styles['card-content']}>
        <div className={clsx(styles['block4'], styles['pulsate'])} />
        <div className={clsx(styles['block3'], styles['pulsate'])} />
        <div className={clsx(styles['block-price'], styles['pulsate'])} />
        <div className={clsx(styles['block-tags'], styles['pulsate'])} />
        <div className={clsx(styles['block-cta'], styles['pulsate'])} />
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
